import { CircularProgress as NovaSpinner, CircularProgressProps as NovaSpinnerProps } from '@fme-nova/components'
import {
  CircularProgressProps as MuiCircularProgressProps,
  default as MuiCircularProgress,
} from '@mui/material/CircularProgress'

import { createComponentWrapperWithRef } from '../../theme'

export const Spinner = createComponentWrapperWithRef<MuiCircularProgressProps | NovaSpinnerProps>(
  {
    mui: MuiCircularProgress,
    nova: NovaSpinner,
  },
  'Spinner',
)
